import { VFC, useMemo } from 'react';
import { TARIFFS, Tariff } from '@enmon/commons';
import { FormattedMessage, useIntl } from 'react-intl';
import { Select } from '../../Select';
import { MeterDetails as messages } from '../../../Form/meter_details/messages';
import { useMeterModelSuggestionsStore } from '../../../../store/useMeterModelSuggestionsStore';
import { getSelectOptionsWithSuggestions } from '../../utils/getSelectOptionsWithSuggestions';

interface TariffsSelectProps {
  value?: Tariff;
  onChange?: (value: Tariff) => void;
}

export const TariffsSelect: VFC<TariffsSelectProps> = ({ ...restProps }) => {
  const intl = useIntl();
  const { meterModelSuggestions } = useMeterModelSuggestionsStore();

  const tariffsOptions = useMemo(
    () =>
      getSelectOptionsWithSuggestions({
        intl,
        values: Object.values(TARIFFS),
        suggestedValue: meterModelSuggestions?.tariffs?.value,
        suggestedSelection: meterModelSuggestions?.tariffs?.selection,
      }),
    [intl, meterModelSuggestions],
  );

  return (
    <Select
      allowClear
      showArrow
      className="w-100"
      options={tariffsOptions}
      placeholder={<FormattedMessage {...messages.numberOfTariffsPlaceholder} />}
      {...restProps}
    />
  );
};
